module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/a1_39b63b9f28cb523cfb7501209ae40a89.png";